import { render, staticRenderFns } from "./warehousingDetail.vue?vue&type=template&id=0caddd4a&"
import script from "./warehousingDetail.vue?vue&type=script&lang=js&"
export * from "./warehousingDetail.vue?vue&type=script&lang=js&"
import style0 from "./warehousingDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0caddd4a')) {
      api.createRecord('0caddd4a', component.options)
    } else {
      api.reload('0caddd4a', component.options)
    }
    module.hot.accept("./warehousingDetail.vue?vue&type=template&id=0caddd4a&", function () {
      api.rerender('0caddd4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/FrontEndWarehouse/components/warehousing/warehousingDetail.vue"
export default component.exports